var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 400,
    viewBox: "0 0 317.49 105.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.8016 57.698 233.94-0.47793s-4.8486-22.446-28.447-17.907c0 0 14.76-2.7267 13.07-17.766-1.69-15.039-9.1247-18.587-21.122-17.573-8.2924 0.70077-14.136 0.71051-22.138 5.7582-7.9084 5.1942-13.441 10.944-13.167 18.477 0 0-6.01-10.548-17.585-8.5206 0 0-3.464 0.50693-6.928 3.2105 0 0 2.0873-12.462-13.326-15.987-15.413-3.5248-30.588 8.8418-29.99 21.507 0 0-13.442-14.696-27.541 4.0624 0 0 3.4363-11.272-16.925-21.495-20.362-10.223-36.245 0.33795-37.935 6.2521-1.6898 5.9141-5.7452 18.672 9.2092 24.839 0 0-23.965-0.50606-21.119 15.62z",
    fill: "#a4dcee",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/cloud3.95c6370c48cef24816859bead84d9853.svg";
export { ForwardRef as ReactComponent };